import { AgGrid } from "@jsq/ds/core";

/**
 * Shared AgGrid utilities for Billing components
 * Contains common grid operations for filtering, sorting, and pagination
 */

export const applyFiltersToGrid = (
  api: AgGrid.GridApi,
  filterModel: AgGrid.FilterModel | null,
): void => {
  if (!filterModel || Object.keys(filterModel).length === 0) return;

  api.setFilterModel(filterModel);
};

export const applySortsToGrid = (
  api: AgGrid.GridApi,
  sortModel: AgGrid.SortModelItem[] | null,
): void => {
  if (!sortModel || sortModel.length === 0) return;

  api.applyColumnState({
    state: sortModel.map((s) => ({
      colId: s.colId,
      sort: s.sort,
    })),
  });
};

export const applyPaginationToGrid = (api: AgGrid.GridApi, pageIndex: number): void => {
  if (pageIndex < 0) return;

  api.paginationGoToPage(pageIndex);
};
